(function (angular, app) {
   "use strict";

   angular.module(app.modules.member.name)
      .controller(app.modules.member.routes.memberdetail.controller, MemberDetailController);

   MemberDetailController.$inject = ["$scope", "$window", "$q", "$timeout", "$routeParams"
       , app.modules.common.constants.appsettings
       , app.modules.common.services.functions
       , app.modules.member.services.search
       , app.modules.invitation.services.invite
       , app.modules.group.services.groups
       , app.modules.outing.services.outings
       , app.modules.scoring.services.score
       , app.modules.handicap.services.handicaps
       , app.modules.ui.services.alerts
       , app.modules.ui.services.ui
   ];

   function MemberDetailController($scope, $window, $q, $timeout, $routeParams
      , ggSettings
      , ggFunctions
      , ggMemberSvc
      , ggInvitations
      , ggGroupSvc
      , ggOutingSvc
      , ggScoringSvc
      , ggHandicapSvc
      , ggAlertSvc
      , ggUISvc
      ) {

      $scope.PopupAlert = new ggAlertSvc.popup;

      var ctrl = this;

      $scope.Temp = {
         isLoaded: false
         , memberId: null
         , member: null
         , profileImage: app.Branding.logoSq
      }


      $scope.View = {
         tabs: {
            current: 1
            , types: {
               home: 1
               , stats : 2
               , groups: 3
            }
            , select: function (v) {

               if (!v) {
                  v = $scope.View.tabs.current;
               }


               $scope.View.tabs.current = v; // Set Current
               app.Member.Session.bookmark.memberdetail.tab = v; // Remember selected tab

            }
            , isActive: function (v) {
               return v == $scope.View.tabs.current;
            }
         }
      }

      $scope.Content = {
         init: function () {
            if (!$scope.Temp.isLoaded) {

               // Last Tab
               var tab1 = app.Member.Session.bookmark.memberdetail.tab;

               $scope.View.tabs.select(tab1);
               ggFunctions.scrollToTop(0);

               if ($scope.Temp.memberId) {

                  var member = null;
                  var groups = [];
                  var scores = [];
                  var club = {};
                  var handicap = {
                     official: null
                     , trend : null
                  };


                  var fetchMember = function () {
                     return ggMemberSvc.search.fetchMemberDetail($scope.Temp.memberId).then(function (data) {
                        $scope.Temp.member = ggFunctions.formatMemberName(data.data);
                        $scope.Temp.member.groups = [];
                        $scope.Temp.member.scores = [];
                        $scope.Temp.member.club = {};
                        if (data.data["photo@odata.mediaContentType"] && data.data["photo@odata.mediaContentType"] != "") {
                           $scope.Temp.profileImage = data.data["photo@odata.mediaReadLink"];
                        }
                        return;
                     });
                  }

                  var fetchClubs = function () {
                     return ggGroupSvc.search.fetchClubSearchByMember({ memberId: $scope.Temp.memberId }).then(function (data) {
                        if (data && data.status == "200") {

                           var clubs = data.data.value;

                           // Check for official / trend handicaps
                           if (clubs.length > 0) {
                              for (var c = 0; c < clubs.length; c++) {
                                 if (clubs[c].isPrimary) {
                                    club = clubs[c];
                                    if ((club.membershipType == "Partial" || club.membershipType == "Full") && club.membershipStatus == "Active") {
                                       if (club.handicaps && club.handicaps.length > 0) {
                                          var hcps = club.handicaps;
                                          for (var h = 0; h < hcps.length; h++) {
                                             var hcp = hcps[h];
                                             if (hcp.isActive) {
                                                if (hcp.isOfficial) {
                                                   handicap.official = hcp;
                                                   if (hcp.isRealTime) {
                                                      hcp.name = "Golf Canada Handicap Factor";
                                                   } else {
                                                      hcp.name = "USGA Handicap Index"
                                                   }
                                                }
                                                if (hcp.isRealTime) {
                                                   handicap.trend = hcp;
                                                }
                                             }
                                          }
                                       }
                                    }
                                 }
                                 
                              }
                           }
                        }
                        return;

                     });
                  }

                  ggFunctions.toggleProcessing(true);
                  fetchMember().then(function () {
                     return fetchClubs();
                  }).finally(function () {
                     $scope.Temp.isLoaded = true;
                     $scope.Temp.member.club = club;
                     $scope.Temp.member.handicap = handicap;
                     ggFunctions.toggleProcessing(false);
                     $scope.Content.scoring.fetch();
                  })

                  
               }

            }
         }
         , groups: {
            results: []
            , isLoaded : false
            , fetch: function () {
               return ggGroupSvc.search.fetchGroupSearchByMember({ memberId: $scope.Temp.memberId }).then(function (data) {
                  groups = data.data.value;
                  return;
               }, function (fail) {
                  return;
               });
            }
         }
         , scoring: {
            results : []
            , isLoaded : false
            , fetch : function(){
               if ($scope.Content.scoring.results.length == 0) {
                  ggScoringSvc.search.fetchScoresByMember({ memberId: $scope.Temp.memberId, top: 20 }).then(function (data) {
                     if (data && data.status == "200") {
                        $scope.Content.scoring.results = data.data.value;
                     }
                  }).finally(function () {
                     $scope.Content.scoring.isLoaded = true;
                  });
               }
            }
         }
      }

      // View Functions
      $scope.f = {
         formatScoreType: function (scoreType) {
            return ggFunctions.formatScoreType(scoreType);
         }
         , formatDateString: function (d) {
            return ggFunctions.formatDateString(d, "mm/yy", null)
         }
      }

      // Page Request Startup
      if ($routeParams) {
         var memberId = $routeParams.memberId;
         if (memberId){
            $scope.Temp.memberId = memberId;
         }
         $scope.Content.init();
      }
   }

}(angular, app));
